import { render, staticRenderFns } from "./WelcomeComponent.vue?vue&type=template&id=845d7e20&scoped=true&"
import script from "./WelcomeComponent.vue?vue&type=script&lang=js&"
export * from "./WelcomeComponent.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeComponent.vue?vue&type=style&index=0&id=845d7e20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845d7e20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})
